import type { NormalizedTool } from "web_myplann/Portfolio/Helpers/investmentToolTypes";

export const getRowKey = (tool: NormalizedTool): string =>
	`${tool.kind}-${tool.id}`;
